module.exports = __webpack_public_path__ + "img/course-student.a3482772.png";